import {
	FeatureServiceBinder,
	FeatureServiceProviderDefinition,
	FeatureServices,
	SharedFeatureService,
} from '@feature-hub/core';
import { AuthServiceProviderV2, IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { IProfileServiceV2, ProfileServiceV2Impl, UserService } from '@vwdfive/myvw-services';
import { BehaviorSubject } from 'rxjs';
import { getBonusById, getMyBonus } from './api/bonus-api';
import { acceptPerson, consentsPerson, createPerson, getPerson, unsuscribePerson } from './api/person-api';
import { confirmVehicle, createVehicle, deleteVehicle, getVehicles } from './api/vehicles-api';
import { PersonAgenda } from './models/agenda';
import { Bonus, PersonBonus } from './models/bonus';
import { IEsOnehubVWConfig } from './models/es-one-hub-config';
import { GetPersonUser, PortalUser, IdentityKitUser } from './models/portal';
import { IdentityKitCompleteMatchForm } from './models/users';
import { DataVehicles } from './models/vehicles';
import { PortalServiceV1 } from './v1';
import { getDataCollection, newAnswerDataCollection } from './api/data-collection-api';
import { DataCollection } from './models/dataCollection';
import { DataMaintenanceTypeDefault } from '../mocks/dataMaintenance.mock';
import { RepairOrderDeafult } from '../mocks/repair-orders.mock';
import {
	Car,
	AppointmentOperation,
	DataMaintenancePlan,
	DataMaintenanceType,
	NewOperationResponse,
	UpdateKmResponse,
	AppointmentDataMaintenance,
} from './models/maintenancePlan';
import { getNextOperations, updateKmApi, newUnofficialOperation, getMaintenancePlan } from './api/maintenance-plan-api';
import { participateEurocup } from '../components/eurocopa/eurocopa-api';

export interface SharedIdentityMatchFeatureService extends SharedFeatureService {
	readonly '1.0.0': FeatureServiceBinder<PortalServiceV1>;
}

export enum IdentityMatchStatus {
	OK = 'OK',
	PENDING = 'PENDING',
}

export interface LayerDependencies extends FeatureServices {
	readonly 'vw:authService': AuthServiceProviderV2;
	readonly 'service-config-provider': ServiceConfigProviderV1;
}

export const portalFeatureServiceDefinition: FeatureServiceProviderDefinition<SharedIdentityMatchFeatureService> = {
	id: 'es:portal-feature-service',
	dependencies: {
		featureServices: {
			['vw:authService']: '2.0.0',
			'service-config-provider': '1.0.0',
		},
	},

	create: ({ featureServices }) => {
		const serviceConfigProvider = featureServices['service-config-provider'] as ServiceConfigProviderV1;
		const authServiceBuilder = featureServices['vw:authService'] as AuthServiceProviderV2;
		const authServiceMarketFag: IAuthServiceV2 = authServiceBuilder.register('market');

		const profileService = new ProfileServiceV2Impl(
			authServiceMarketFag,
			serviceConfigProvider.configs['customer-profile']!.urlOrigin,
		);
		const userService = new UserService(authServiceMarketFag);

		const esOnehubVWConfig = serviceConfigProvider.configs['es-onehub-vw']?.customConfig as IEsOnehubVWConfig;
		const vwdata = serviceConfigProvider.configs['es-vwdata'];

		const personInfo: BehaviorSubject<GetPersonUser | null> = new BehaviorSubject<GetPersonUser | null>(null);

		const userIdentityKitLogged: BehaviorSubject<IdentityKitUser> = new BehaviorSubject<IdentityKitUser>({
			identityKitId: null,
			email: null,
			firstName: null,
			lastName: null,
			salutation: null,
			academicTitle: null,
			phoneNumber: null,
			phoneNumbers: null,
		} as IdentityKitUser);

		const validationStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

		const personVehicles: BehaviorSubject<DataVehicles | null> = new BehaviorSubject<DataVehicles | null>(null);

		const personAgenda: BehaviorSubject<PersonAgenda | null> = new BehaviorSubject<PersonAgenda | null>(null);

		const personDataCollection: BehaviorSubject<DataCollection | null> = new BehaviorSubject<DataCollection | null>(
			null,
		);

		////////////////////////////
		//Variables mantenimientos//
		////////////////////////////
		let VehicleInfo: Car = {
			comercialDenomination: 'example_comercialDenomination',
			commercialDenominationSli: 'example_commercialDenominationSli',
			modelDescr: 'example_modelDescr',
			tmaimg: 'example_tmaimg',
			licenseDate: -99,
			license: 'example_license',
			climaProKM: -99,
			vehicleClimaproId: -99,
			frame: 'example_frame',
			vin: 'example_vin',
			image: 'example_image',
			editKm: false,
			km: 0,
			localKM: 0,
			maintenanceYears: 0,
			maintenanceMonths: 0,
			maintenanceDays: 0,
			maintenanceTotalDays: 0,
			maintenance: DataMaintenanceTypeDefault,
			alertNextMaintenance: false,
			repairOrders: RepairOrderDeafult,
			familyModelDesc: '',
			modelYear: '',
		};

		const quoteOperations: AppointmentOperation[] = [
			{
				id: '2',
				name: 'Bujías (todas)',
			},
		];
		const operation: AppointmentOperation[] = [
			{
				id: 'id',
				name: 'tramo mantenimiento',
			},
		];
		let appointmentData: AppointmentDataMaintenance = {
			featureApp: 'es-maintenance-plan',
			vehicle: [VehicleInfo],
			quoteOperations: quoteOperations,
			quotePvp: null,
			operation: operation,
		};

		///////////////////
		//Variables bonos//
		///////////////////
		const personBonus: BehaviorSubject<PersonBonus | null> = new BehaviorSubject<PersonBonus | null>(null);

		const portalFeatureService_1_0_0 = {
			featureService: {
				//Gestion de Login
				getPerson: (): BehaviorSubject<GetPersonUser | null> => {
					if (!personInfo.getValue()) {
						portalFeatureService_1_0_0.featureService
							.isAuthenticated(authServiceMarketFag, profileService, userService)
							.then((identityKit) => {
								if (identityKit && identityKit.identityKitId) {
									getPerson(authServiceMarketFag, esOnehubVWConfig)
										.then((response) => {
											personInfo.next({
												identityKitUser: identityKit,
												portalUser: response as unknown as PortalUser,
											});
											console.log('🚀 ~ .then ~ personInfo', personInfo.getValue());
										})
										.catch((err) => {
											console.error(err);
										});
								}
							});
					}

					return personInfo;
				},

				isAuthenticated: async (
					authServiceInstance: IAuthServiceV2,
					profileService: IProfileServiceV2,
					userService: UserService,
				): Promise<IdentityKitUser | undefined> => {
					const logged = await authServiceInstance?.isAuthenticated();
					if (logged) {
						validationStatus.next(false);
						const userProfile = await profileService.getUserProfile();
						const email = await userService.getCurrentUserEmail();
						const identityKitId = await userService.getCurrentUserId();

						const identityKitUser = {
							...userProfile,
							email: email,
							identityKitId: identityKitId,
						} as IdentityKitUser;

						userIdentityKitLogged.next(identityKitUser);

						console.log('🚀 ~ App ~ identityKitUser', identityKitUser);
						return identityKitUser;
					} else {
						validationStatus.next(true);
					}
					return;
				},

				hasToLog: (): BehaviorSubject<boolean> => validationStatus,

				createPerson: (
					formValues: IdentityKitCompleteMatchForm,
					perfiladoComercial: string,
					device: string,
					tc: string,
					url: string,
				): BehaviorSubject<GetPersonUser | null> => {
					(async (): Promise<PortalUser> => {
						const createPersonData = createPerson(authServiceMarketFag, esOnehubVWConfig, {
							personalData: {
								name: formValues?.name || '',
								firstSurname: formValues?.surname1 || '',
								secondSurname: formValues?.surname2 || '',
								documentType: formValues?.typeDocument || '',
								documentValue: formValues?.document || '',
								email: personInfo.getValue()?.identityKitUser.email as string,
								identitykitId: personInfo.getValue()?.identityKitUser.identityKitId as string,
							},
							vwClubData: {
								perfiladoComercial: perfiladoComercial,
								originDeviceType: device,
								originTrackingCode: tc,
								formUrl: url,
							},
						}) as unknown as PortalUser;
						return createPersonData;
					})()
						.then((createdPerson) => {
							portalFeatureService_1_0_0.featureService
								.isAuthenticated(authServiceMarketFag, profileService, userService)
								.then((identityKit) => {
									if (identityKit && identityKit.identityKitId) {
										personInfo.next({
											identityKitUser: identityKit,
											portalUser: createdPerson,
										});
									}
								});
						})
						.catch(() => {
							personInfo.next(null);
						});
					return personInfo;
				},

				acceptPerson: (
					perfiladoComercial: string,
					device: string,
					tc: string,
					url: string,
				): BehaviorSubject<GetPersonUser | null> => {
					(async (): Promise<PortalUser> => {
						const acceptPersonData = acceptPerson(authServiceMarketFag, esOnehubVWConfig, {
							vwClubData: {
								perfiladoComercial: perfiladoComercial,
								originDeviceType: device,
								originTrackingCode: tc,
								formUrl: url,
							},
						}) as unknown as PortalUser;
						return acceptPersonData;
					})()
						.then((acceptedPerson) => {
							portalFeatureService_1_0_0.featureService
								.isAuthenticated(authServiceMarketFag, profileService, userService)
								.then((identityKit) => {
									if (identityKit && identityKit.identityKitId) {
										personInfo.next({
											identityKitUser: identityKit,
											portalUser: acceptedPerson,
										});
									}
								});
						})
						.catch(() => {
							personInfo.next(null);
						});
					return personInfo;
				},

				//Consentimietos de la persona
				consentsPerson: (notificaciones: boolean): BehaviorSubject<GetPersonUser | null> => {
					const person = new BehaviorSubject<GetPersonUser | null>(null);
					(async (): Promise<GetPersonUser> => {
						const consentsPersonData = consentsPerson(authServiceMarketFag, esOnehubVWConfig, {
							notificaciones: notificaciones,
						}) as unknown as GetPersonUser;
						return consentsPersonData;
					})()
						.then((personConsents) => {
							person.next(personConsents);
						})
						.catch(() => {
							person.next(null);
						});

					return person;
				},

				//Baja del club volkswagen
				unsuscribePerson: (): BehaviorSubject<GetPersonUser | null> => {
					(async (): Promise<PortalUser> => {
						const acceptPersonData = unsuscribePerson(authServiceMarketFag, esOnehubVWConfig) as unknown as PortalUser;
						return acceptPersonData;
					})()
						.then((unsuscribedPerson) => {
							portalFeatureService_1_0_0.featureService
								.isAuthenticated(authServiceMarketFag, profileService, userService)
								.then((identityKit) => {
									if (identityKit && identityKit.identityKitId) {
										personInfo.next({
											identityKitUser: identityKit,
											portalUser: unsuscribedPerson,
										});
									}
								});
						})
						.catch(() => {
							return null;
						});
					return personInfo;
				},

				//Gestion de vehiculos
				getPersonVehicles: (): BehaviorSubject<DataVehicles | null> => {
					if (!personVehicles.getValue() && !personVehicles.observed) {
						const identityKitUser = userIdentityKitLogged.getValue().identityKitId;

						if (identityKitUser) {
							(async (): Promise<DataVehicles> => {
								const vehicles = (await getVehicles(authServiceMarketFag, esOnehubVWConfig))?.data;
								return vehicles;
							})().then((userVehicles) => {
								if (userVehicles.orders) {
									userVehicles.vehicles = [...userVehicles.vehicles, ...userVehicles.orders];
								}
								personVehicles.next(userVehicles);
							});
						}
					}
					return personVehicles;
				},

				//Gestion de agenda
				getPersonAgenda: (): BehaviorSubject<PersonAgenda | null> => {
					if (!personAgenda.getValue()) {
						(async (): Promise<PersonAgenda> => {
							const dataUrl = vwdata ? `${vwdata.urlOrigin}${vwdata.urlPath}` : null;
							const agendas = await fetch(dataUrl + '/getAgendasPortal').then((response) => response.json());
							return agendas;
						})().then((agenda) => {
							personAgenda.next(agenda);
						});
					}
					return personAgenda;
				},

				//Gestion de coches journey
				confirmPersonVehicle: (frame: string): BehaviorSubject<DataVehicles | null> => {
					const vehicles = new BehaviorSubject<DataVehicles | null>(null);

					(async (): Promise<DataVehicles> => {
						const updatedVehicles = (await confirmVehicle(authServiceMarketFag, esOnehubVWConfig, frame))?.data;

						return updatedVehicles;
					})()
						.then((updatedVehicles) => {
							if (updatedVehicles?.orders) {
								updatedVehicles.vehicles = [...updatedVehicles.vehicles, ...updatedVehicles.orders];
							}
							personVehicles.next(updatedVehicles);
							vehicles.next(updatedVehicles);
						})
						.catch(() => {
							vehicles.next(null);
						});

					return vehicles;
				},

				deletePersonVehicle: (frame: string): BehaviorSubject<DataVehicles | null> => {
					const vehicles = new BehaviorSubject<DataVehicles | null>(null);

					(async (): Promise<DataVehicles> => {
						const updatedVehicles = (await deleteVehicle(authServiceMarketFag, esOnehubVWConfig, frame))?.data;

						return updatedVehicles;
					})()
						.then((updatedVehicles: DataVehicles | null) => {
							if (updatedVehicles?.orders) {
								updatedVehicles.vehicles = [...updatedVehicles.vehicles, ...updatedVehicles.orders];
							}
							personVehicles.next(updatedVehicles);
							vehicles.next(updatedVehicles);
						})
						.catch(() => {
							vehicles.next(null);
						});
					return vehicles;
				},

				createPersonVehicle: (
					frame: string,
					license: string,
					fichaTecnica: File,
					permisoCirculacion: File,
				): BehaviorSubject<DataVehicles | null> => {
					const vehicles = new BehaviorSubject<DataVehicles | null>(null);

					(async (): Promise<DataVehicles> => {
						const createdVehicle = (
							await createVehicle(
								authServiceMarketFag,
								esOnehubVWConfig,
								frame,
								license,
								fichaTecnica,
								permisoCirculacion,
							)
						)?.data;

						return createdVehicle;
					})()
						.then((createdVehicle) => {
							if (createdVehicle.orders) {
								createdVehicle.vehicles = [...createdVehicle.vehicles, ...createdVehicle.orders];
							}
							personVehicles.next(createdVehicle);
							vehicles.next(createdVehicle);
						})
						.catch((error) => {
							vehicles.next(error);
						});
					return vehicles;
				},

				//Gestion de Data collection
				getPersonDataCollection: (): BehaviorSubject<DataCollection | null> => {
					if (!personDataCollection.getValue() && !personDataCollection.observed) {
						const identityKitUser = userIdentityKitLogged.getValue().identityKitId;

						if (identityKitUser) {
							(async (): Promise<DataCollection> => {
								const dataCollection = (await getDataCollection(authServiceMarketFag, esOnehubVWConfig))?.data;
								return dataCollection;
							})().then((data) => {
								personDataCollection.next(data);
							});
						}
					}
					return personDataCollection;
				},

				//Gestion de new answer Data collection
				newPersonAnswerDataCollection: (questionAnswer: string[]): BehaviorSubject<DataCollection | null> => {
					(async (): Promise<DataCollection> => {
						const newAnswer = (await newAnswerDataCollection(authServiceMarketFag, esOnehubVWConfig, questionAnswer))
							?.data;
						return newAnswer;
					})()
						.then((updatedDataCollection) => {
							personDataCollection.next(updatedDataCollection);
						})
						.catch(() => {
							return null;
						});
					return personDataCollection;
				},

				////////////////////////////
				//Llamadas mantenimientos//
				////////////////////////////
				getOperationCategories: async (userIdentityKit: string): Promise<DataMaintenanceType> => {
					const operationCategories = (await getNextOperations(authServiceMarketFag, esOnehubVWConfig, userIdentityKit))
						?.data;
					return operationCategories;
				},

				getMaintenancePlan: async (): Promise<DataMaintenancePlan> => {
					try {
						const vehicles = (await getMaintenancePlan(authServiceMarketFag, esOnehubVWConfig))?.data;
						return vehicles;
					} catch (e) {
						console.log(e);
						return new Promise((resolve) => {
							resolve({
								vehicles: [],
								identitykitId: '',
								climaproId: '',
								email: '',
								name: '',
								firstSurname: '',
								secondSurname: '',
							} as any);
						});
					}
				},

				updateKmApi: async (userIdentityKit: string, frame: string, km: number): Promise<UpdateKmResponse> => {
					const updateKm = (await updateKmApi(authServiceMarketFag, esOnehubVWConfig, userIdentityKit, frame, km))
						?.data;
					return updateKm;
				},

				newUnofficialOperation: async (
					userIdentityKit: string,
					frame: string,
					kms: number,
					date: Date,
					garage: string,
					operation: string,
				): Promise<NewOperationResponse> => {
					const addedNewUnofficialOperation = (
						await newUnofficialOperation(
							authServiceMarketFag,
							esOnehubVWConfig,
							userIdentityKit,
							frame,
							kms,
							date,
							garage,
							operation,
						)
					)?.data;
					return addedNewUnofficialOperation;
				},

				getAppointmentData: (): AppointmentDataMaintenance => appointmentData,

				setAppointmentData: (operations: any, operation: any): void => {
					appointmentData = {
						...appointmentData,
						vehicle: [VehicleInfo],
						quoteOperations: operations
							? operations.map((operation: any) => {
									return {
										id: operation,
										name: operation?.name,
									};
								})
							: undefined,
						operation: operation,
					};
				},

				setCarInfo: (carInfo: Car): void => {
					VehicleInfo = {
						...carInfo,
					} as Car;
				},

				//////////////////
				//Llamadas Bonos//
				//////////////////
				getPersonBonus: (): BehaviorSubject<PersonBonus | null> => {
					if (!personBonus.getValue()) {
						(async (): Promise<PersonBonus> => {
							return (await getMyBonus(authServiceMarketFag, esOnehubVWConfig))?.data;
						})().then((bonus) => {
							personBonus.next(bonus);
						});
					}
					return personBonus;
				},

				getBonusDetail: (id: string): Promise<Bonus | null> => {
					const personBonusValue = personBonus.getValue();
					const bonusCars = personBonusValue?.bonusForCars.flatMap((car) => car.bonus ?? []) || [];

					const allBonus = [
						...(personBonusValue?.bonusEnjoyed ?? []),
						...bonusCars,
						...(personBonusValue?.bonusForYou ?? []),
					];

					const bonusDetail = allBonus.find((bonus) => bonus.id === id);

					if (bonusDetail) {
						return Promise.resolve(bonusDetail);
					} else {
						return getBonusById(authServiceMarketFag, esOnehubVWConfig, id).then((bonus) => (bonus ? bonus : null));
					}
				},

				///
				////
				/////
				/////
				/////
				///// BORRAR EUROCOPA
				postParticipateEurocup: (): BehaviorSubject<GetPersonUser | null> => {
					(async (): Promise<PortalUser> => {
						const personParticipateEurocup = participateEurocup(
							authServiceMarketFag,
							esOnehubVWConfig,
						) as unknown as PortalUser;
						return personParticipateEurocup;
					})()
						.then((personParticipateEurocup) => {
							portalFeatureService_1_0_0.featureService
								.isAuthenticated(authServiceMarketFag, profileService, userService)
								.then((identityKit) => {
									if (identityKit && identityKit.identityKitId) {
										personInfo.next({
											identityKitUser: identityKit,
											portalUser: personParticipateEurocup,
										});
									}
								});
						})
						.catch(() => {
							personInfo.next(null);
						});
					return personInfo;
				},
			},
		};
		return {
			'1.0.0': () => portalFeatureService_1_0_0,
		};
	},
};
